import {reactive, ref} from 'vue';
import type {NavbarStateResource} from '@navbar-api';
import {NavbarStateResourceNavbarDisplayModeEnum} from '@navbar-api';
import {defineStore} from 'pinia';

export const useNavbarStateStore = defineStore('navbar-state', () => {
    const pending = ref(false);

    const isEnforcedIdentity = ref(false);
    const state = reactive<NavbarStateResource>({
        navbarDisplayMode: NavbarStateResourceNavbarDisplayModeEnum.Full,
        isBusinessReferralOnboardingAcknowledged: false,
    });

    function updateNavbarDisplayMode(newNavbarDisplayMode: NavbarStateResourceNavbarDisplayModeEnum): void {
        state.navbarDisplayMode = newNavbarDisplayMode;
    }

    return {
        pending,
        state,
        isEnforcedIdentity,
        updateNavbarDisplayMode,
    };
});
